"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var HeroSection_1 = require("@/components/home/HeroSection");
var HowItWorksSection_1 = require("@/components/home/HowItWorksSection");
var WhatEarnsMedalsSection_1 = require("@/components/home/WhatEarnsMedalsSection");
var MedalsSection_1 = require("@/components/home/MedalsSection");
var HowToUseMedalsSection_1 = require("@/components/home/HowToUseMedalsSection");
var JoiningIsEasySection_1 = require("@/components/home/JoiningIsEasySection");
var ForMunicipalitiesSection_1 = require("@/components/home/ForMunicipalitiesSection");
var CompanySection_1 = require("@/components/home/CompanySection");
var ContactSection_1 = require("@/components/home/ContactSection");
var LanguageContext_1 = require("@/contexts/LanguageContext");
var usePageMeta_1 = require("@/hooks/usePageMeta");
var Index = function () {
    var t = (0, LanguageContext_1.useLanguage)().t;
    var location = (0, react_router_dom_1.useLocation)();
    (0, usePageMeta_1.usePageMeta)({
        title: t("meta.homeTitle"),
        description: t("meta.homeDescription"),
        path: "/",
    });
    (0, react_1.useEffect)(function () {
        if (location.hash) {
            var id = location.hash.replace("#", "");
            var el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [location.hash]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HeroSection_1.default, {}), (0, jsx_runtime_1.jsx)(HowItWorksSection_1.default, {}), (0, jsx_runtime_1.jsx)(WhatEarnsMedalsSection_1.default, {}), (0, jsx_runtime_1.jsx)(MedalsSection_1.default, {}), (0, jsx_runtime_1.jsx)(HowToUseMedalsSection_1.default, {}), (0, jsx_runtime_1.jsx)(JoiningIsEasySection_1.default, {}), (0, jsx_runtime_1.jsx)(ForMunicipalitiesSection_1.default, {}), (0, jsx_runtime_1.jsx)(CompanySection_1.default, {}), (0, jsx_runtime_1.jsx)(ContactSection_1.default, {})] }));
};
exports.default = Index;
